// import React from "react"
// import { ReactComponent as Galactical } from "../../assets/galacticalCube.svg"
// import { ReactComponent as Solar } from "../../assets/solarCube.svg"
// import { ReactComponent as Stellar } from "../../assets/stellarCube.svg"
// import { ReactComponent as Stone } from "../../assets/stoneCube.svg"

import solar from "../../assets/solar.png"
import stellar from "../../assets/stellar.png"
import galactical from "../../assets/galactical.png"
import stone from "../../assets/stone.png"

const typeOfJackpots = [
  {
    text: "solar",
    svg: solar,
    color: "#C9D8C5",
    background:
      "linear-gradient(359.82deg, #282835 2.69%, #653731 55.55%, #F15A29 95.42%)",
    shadow: "inset 0px 0px 4.21429px rgba(245, 230, 91, 0.3)",
  },
  {
    text: "galactical",
    svg: galactical,
    color: "#C7BEFA",
    background:
      "linear-gradient(359.82deg, #282835 2.69%, #393165 55.55%, #5A5DF6 95.42%)",
    shadow: "inset 0px 0px 4.21429px rgba(159, 91, 245, 0.3)",
  },
  {
    text: "stellar",
    svg: stellar,
    color: "#C9D8C5",
    background:
      "linear-gradient(359.82deg, #282835 2.69%, #653731 55.55%, #D73333 95.42%)",
    shadow: "inset 0px 0px 4.21429px rgba(159, 91, 245, 0.3)",
  },
  {
    text: "break cube",
    svg: stone,
    color: "#C7BEFA",
    background:
      "radial-gradient(324.83% 67.39% at 50% 50%, #282835 0%, #36366A 72.4%, #292930 100%)",
    shadow: "inset 0px 0px 4.21429px rgba(91, 95, 245, 0.3)",
  },
]

export default typeOfJackpots
